module.exports = __webpack_public_path__ + "static/media/icon-location.9c1f7f75.svg";